import { ArcCellInfo, ArcStack, ArcText } from "@src/core/ui";
import { MissionDetailsProps } from "./types";
import React from "react";
import { arcSpatium } from "@src/core/extensions";
import ToggleCollapseView from '@src/features/drone/components/toggle-collapse-view';


export const MissionDetails: React.FC<MissionDetailsProps> = (props) => {
  const { order } = props;

  if (!order) return (<ToggleCollapseView label="MISSION DETAILS" defaultOpen={false} sx={{ marginTop: 2 }}>
    <ArcStack>
      <ArcText.h5 color="text.secondary" fontSize={12}>Order is loading...</ArcText.h5>
    </ArcStack>
  </ToggleCollapseView>);

  const getOrderInfo = () => {
    const orderData = order as Record<string, any>;
    return {
      id: orderData?.id || "N/A",
      packageContent: orderData?.packageContent || "N/A",
      clientName: orderData?.clientName || "N/A",
      deliveryLocation: orderData?.deliveryLocation,
      flightAltitude: orderData?.flightAltitude || 0,
      deliveryAltitude: orderData?.deliveryAltitude || 0,
    };
  };

  const orderInfo = getOrderInfo();

  return (
    <ToggleCollapseView label="MISSION DETAILS" defaultOpen={false} sx={{ marginTop: 2}}>
      <ArcStack
        padding={1.5}
        paddingBottom={1.7}
        width="100%"
        borderRadius={1}
        bgcolor="background.paper"
        marginTop={1}
      >

        <ArcStack
          spacing={2}
          sx={{ color: "white", marginLeft: '18px'}}
        >
          <ArcStack direction="row" justifyContent="space-between" spacing={1}>
            <ArcStack spacing={2} flex={1}>
              <ArcCellInfo label="ORDER" textProps={{ fontWeight: 400 }}>#{orderInfo.id}</ArcCellInfo>
              <ArcCellInfo label="PACKAGE CONTENT" sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }} textProps={{ fontWeight: 400 }}>
                {orderInfo.packageContent}
              </ArcCellInfo>
            </ArcStack>

            <ArcStack spacing={2} flex={1}>

              <ArcCellInfo label="DELIVERY ALTITUDE" textProps={{ fontWeight: 400 }}>  
                {arcSpatium(orderInfo.deliveryAltitude)}
              </ArcCellInfo>

              <ArcCellInfo label="CLIENT NAME" sx={{ wordBreak: 'break-word', whiteSpace: 'normal' }} textProps={{ fontWeight: 400 }}>
                {orderInfo.clientName}
              </ArcCellInfo>

            </ArcStack>
          </ArcStack>

          <ArcCellInfo label="DESTINATION" sx={{ maxWidth: "300px" }} textProps={{ fontWeight: 400 }}>
            {orderInfo.deliveryLocation?.address || "N/A"}
          </ArcCellInfo>

        </ArcStack>
      </ArcStack>
    </ToggleCollapseView>
  );
};